var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56442 4.77279C7.75568 4.43347 8.24432 4.43346 8.43558 4.77279L10.4269 8.30569C10.4982 8.43228 10.6211 8.52157 10.7636 8.55031L14.7389 9.35241C15.1207 9.42945 15.2717 9.89417 15.0081 10.1809L12.2634 13.1665C12.1651 13.2735 12.1182 13.4179 12.1348 13.5623L12.6004 17.5909C12.6452 17.9778 12.2498 18.2651 11.8957 18.103L8.20808 16.4152C8.07595 16.3548 7.92405 16.3548 7.79192 16.4152L4.10434 18.103C3.75016 18.2651 3.35484 17.9778 3.39956 17.5909L3.86516 13.5623C3.88185 13.4179 3.83491 13.2735 3.73656 13.1665L0.991913 10.1809C0.728299 9.89417 0.879296 9.42945 1.26111 9.35241L5.23645 8.55031C5.37889 8.52157 5.50178 8.43228 5.57313 8.30569L7.56442 4.77279Z",
    fill: "#F7E691"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.52744L13.7735 11.674C13.9519 11.9904 14.2591 12.2136 14.6152 12.2855L18.1558 12.9999L15.7113 15.6589L16.2634 16.1665L15.7113 15.6589C15.4654 15.9263 15.3481 16.2875 15.3898 16.6484L15.8045 20.2364L12.5202 18.7333C12.1899 18.5821 11.8101 18.5821 11.4798 18.7333L8.19553 20.2364L8.6102 16.6484C8.65191 16.2875 8.53456 15.9263 8.2887 15.6589L5.84423 12.9999L9.38479 12.2855C9.74089 12.2136 10.0481 11.9904 10.2265 11.674L12 8.52744ZM12.2175 8.14159L12.2178 8.14105L12 8.0183L12.2178 8.14105C12.2177 8.14123 12.2176 8.14141 12.2175 8.14159Z",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16016 6.16016L6.00049 8.00044",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6L18 8",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L12 5",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/Rating.1fbe5ab3a61b064fd358a4521f638442.svg";
export { ForwardRef as ReactComponent };